/** Parse DD/MM/YYYY (or already YYYY-MM-DD) into YYYY-MM-DD. */
export const toYearMonthDay = (value) => {
  if (value == null || value === "") {
    return null;
  }
  const raw = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {
    return raw;
  }
  const match = raw.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
  if (!match) {
    return null;
  }
  const [, day, month, year] = match;
  return `${year}-${month}-${day}`;
};

const addOneUtcCalendarDay = (yyyyMmDd) => {
  const [year, month, day] = yyyyMmDd.split("-").map(Number);
  const next = new Date(Date.UTC(year, month - 1, day + 1));
  return next.toISOString().slice(0, 10);
};

/**
 * Calendar day range → UTC ISO bounds for Breakage API filters.
 * From is inclusive midnight UTC; To is exclusive (next calendar day midnight UTC).
 */
export const toUtcExclusiveDayRange = (startDate, endDate) => {
  const startYmd = toYearMonthDay(startDate);
  const endYmd = toYearMonthDay(endDate);
  if (!startYmd || !endYmd) {
    return null;
  }
  return {
    from: `${startYmd}T00:00:00.000Z`,
    to: `${addOneUtcCalendarDay(endYmd)}T00:00:00.000Z`,
  };
};

const utcIsoToYearMonthDay = (iso) => {
  if (iso == null || iso === "") {
    return null;
  }
  const match = String(iso).trim().match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : null;
};

const subtractOneUtcCalendarDay = (yyyyMmDd) => {
  const [year, month, day] = yyyyMmDd.split("-").map(Number);
  const prev = new Date(Date.UTC(year, month - 1, day - 1));
  return prev.toISOString().slice(0, 10);
};

const yearMonthDayToDisplay = (yyyyMmDd) => {
  if (!yyyyMmDd) {
    return null;
  }
  const [year, month, day] = yyyyMmDd.split("-");
  return `${day}/${month}/${year}`;
};

/** Inclusive UTC from bound → DD/MM/YYYY label. */
export const formatUtcInclusiveDayLabel = (isoFrom) =>
  yearMonthDayToDisplay(utcIsoToYearMonthDay(isoFrom));

/**
 * Exclusive UTC to bound → DD/MM/YYYY of the last included calendar day
 * (day before the exclusive bound).
 */
export const formatUtcExclusiveToLabel = (isoTo) => {
  const ymd = utcIsoToYearMonthDay(isoTo);
  if (!ymd) {
    return null;
  }
  return yearMonthDayToDisplay(subtractOneUtcCalendarDay(ymd));
};
